import { PRODUCT_URLS } from '@podus/utils';

export interface HeroProduct {
    /** Path to the product mark in `public/logo`. */
    logo: string;
    /** Product name, rendered bold after the `Podus` prefix. */
    name: string;
    prefix: string;
    href: string;
    comingSoon: boolean;
}

/**
 * The Podus products surfaced in the hero.
 *
 * A function rather than a const because `PRODUCT_URLS` uses lazy getters — the environment is
 * resolved at access time, not at module-import time.
 */
export function getHeroProducts(): HeroProduct[] {
    return [
        { logo: '/logo/podus-ai.svg', name: 'AI', prefix: 'Podus', href: PRODUCT_URLS.chatpodusai, comingSoon: false },
        { logo: '/logo/podus-aids.svg', name: 'Aid', prefix: 'Podus', href: PRODUCT_URLS.podusaid, comingSoon: false },
        {
            logo: '/logo/podus-appointment.svg',
            name: 'Appointment',
            prefix: 'Podus',
            href: PRODUCT_URLS.podusappointment,
            comingSoon: false,
        },
        {
            logo: '/logo/podus-contract.svg',
            name: 'Contract',
            prefix: 'Podus',
            href: PRODUCT_URLS.poduscontract,
            comingSoon: false,
        },
        {
            logo: '/logo/podus-cheaker.svg',
            name: 'Checker',
            prefix: 'Podus',
            href: PRODUCT_URLS.poduschecker,
            comingSoon: false,
        },
        {
            logo: '/logo/podus-multidoor.svg',
            name: 'Multidoor',
            prefix: 'Podus',
            href: PRODUCT_URLS.podusmultidoor,
            comingSoon: true,
        },
    ];
}
